module.exports = __webpack_public_path__ + "static/media/photo60.7920791e.jpg";